import configRoutes from './config';
import utilityRoutes from './utility';

export default [
    {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "js/home" */ '@views/home/index')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        redirect: to => ({ path: '/home', query: to.query })
    },
    {
        path: '/change/password',
        name: 'changePassword',
        component: () => import(/* webpackChunkName: "js/auth/changePassword" */ '@views/auth/change-password')
    },
    {
        path: '/setup',
        name: 'setup',
        component: () => import(/* webpackChunkName: "js/setup" */ '@views/setup/index')
    },
    {
        path: '/configuration',
        component: () => import(/* webpackChunkName: "js/configuration" */ '@views/configuration/layout/index'),
        children: [
            ...configRoutes
        ]
    },
    {
        path: '/utility',
        component: () => import(/* webpackChunkName: "js/utility" */ '@views/utility/layout/index'),
        children: [
            ...utilityRoutes
        ]
    },
    {
        path: '/academic',
        name: 'academic',
        component: () => import(/* webpackChunkName: "js/academic/index" */ '@views/academic/index')
    },
    {
        path: '/academic/session',
        name: 'academicSession',
        component: () => import(/* webpackChunkName: "js/academic/session/index" */ '@views/academic/session/index')
    },
    {
        path: '/academic/session/:id/edit',
        name: 'academicSessionEdit',
        component: () => import(/* webpackChunkName: "js/academic/session/index" */ '@views/academic/session/index')
    },
    {
        path: '/finance/account',
        name: 'financeAccount',
        component: () => import(/* webpackChunkName: "js/finance/account/index" */ '@views/finance/account/index')
    },
    {
        path: '/finance/account/:id/edit',
        name: 'financeAccountEdit',
        component: () => import(/* webpackChunkName: "js/finance/account/index" */ '@views/finance/account/index')
    },
    {
        path: '/finance/account/:id',
        name: 'financeAccountStatement',
        component: () => import(/* webpackChunkName: "js/finance/account/statement" */ '@views/finance/account/statement')
    },
    {
        path: '/finance/report',
        name: 'financeReport',
        component: () => import(/* webpackChunkName: "js/finance/report" */ '@views/finance/report')
    },
    {
        path: '/finance/fee/report/summary',
        name: 'financeFeeSummaryReport',
        component: () => import(/* webpackChunkName: "js/finance/fee/report/summary" */ '@views/finance/fee/report/summary')
    },
    {
        path: '/finance/fee/report/concession',
        name: 'financeFeeConcessionReport',
        component: () => import(/* webpackChunkName: "js/finance/fee/report/concession" */ '@views/finance/fee/report/concession')
    },
    {
        path: '/finance/fee/report/due',
        name: 'financeFeeDueReport',
        component: () => import(/* webpackChunkName: "js/finance/fee/report/due" */ '@views/finance/fee/report/due')
    },
    {
        path: '/finance/fee/report/payment',
        name: 'financeFeePaymentReport',
        component: () => import(/* webpackChunkName: "js/finance/fee/report/payment" */ '@views/finance/fee/report/payment')
    },
    {
        path: 'finance/fee/report/refund',
        name: 'financeFeeRefundReport',
        component: () => import(/* webpackChunkName: "js/finance/fee/report/refund" */ '@views/finance/fee/report/refund')
    },
    {
        path: '/finance/transaction/report/summary',
        name: 'financeTransactionSummaryReport',
        component: () => import(/* webpackChunkName: "js/finance/transaction/report/summary" */ '@views/finance/transaction/report/summary')
    },
    {
        path: '/finance/transaction/report/day-book',
        name: 'financeTransactionDayBookReport',
        component: () => import(/* webpackChunkName: "js/finance/transaction/report/dayBook" */ '@views/finance/transaction/report/day-book')
    },
    {
        path: '/employee',
        name: 'employee',
        component: () => import(/* webpackChunkName: "js/employee/index" */ '@views/employee/index')
    },
    {
        path: '/employee/import',
        name: 'employeeImport',
        component: () => import(/* webpackChunkName: "js/employee/import/index" */ '@views/employee/import/index')
    },
    {
        path: '/employee/id-card',
        name: 'employeeIdCard',
        component: () => import(/* webpackChunkName: "js/employee/idCard/index" */ '@views/employee/id-card/index')
    },
    {
        path: '/employee/leave',
        name: 'employeeLeave',
        component: () => import(/* webpackChunkName: "js/employee/leave/index" */ '@views/employee/leave/index')
    },
    {
        path: '/employee/leave/allocation',
        name: 'employeeLeaveAllocation',
        component: () => import(/* webpackChunkName: "js/employee/leave/allocation/index" */ '@views/employee/leave/allocation/index')
    },
    {
        path: '/employee/leave/allocation/:uuid/edit',
        name: 'employeeLeaveAllocationEdit',
        component: () => import(/* webpackChunkName: "js/employee/leave/allocation/edit" */ '@views/employee/leave/allocation/edit')
    },
    {
        path: '/employee/leave/request',
        name: 'employeeLeaveRequest',
        component: () => import(/* webpackChunkName: "js/employee/leave/request/index" */ '@views/employee/leave/request/index')
    },
    {
        path: '/employee/leave/request/create',
        name: 'employeeLeaveRequestCreate',
        component: () => import(/* webpackChunkName: "js/employee/leave/request/create" */ '@views/employee/leave/request/create')
    },
    {
        path: '/employee/leave/request/:uuid/edit',
        name: 'employeeLeaveRequestEdit',
        component: () => import(/* webpackChunkName: "js/employee/leave/request/edit" */ '@views/employee/leave/request/edit')
    },
    {
        path: '/employee/leave/request/:uuid',
        name: 'employeeLeaveRequestDetail',
        component: () => import(/* webpackChunkName: "js/employee/leave/request/show" */ '@views/employee/leave/request/show')
    },
    {
        path: '/employee/payroll',
        name: 'employeePayroll',
        component: () => import(/* webpackChunkName: "js/employee/payroll/index" */ '@views/employee/payroll/index')
    },
    {
        path: '/employee/payroll/template',
        name: 'employeePayrollTemplate',
        component: () => import(/* webpackChunkName: "js/employee/payroll/template/index" */ '@views/employee/payroll/template/index')
    },
    {
        path: '/employee/payroll/template/create',
        name: 'employeePayrollTemplateCreate',
        component: () => import(/* webpackChunkName: "js/employee/payroll/template/create" */ '@views/employee/payroll/template/create')
    },
    {
        path: '/employee/payroll/template/:uuid/edit',
        name: 'employeePayrollTemplateEdit',
        component: () => import(/* webpackChunkName: "js/employee/payroll/template/edit" */ '@views/employee/payroll/template/edit')
    },
    {
        path: '/employee/payroll/salary',
        name: 'employeePayrollSalary',
        component: () => import(/* webpackChunkName: "js/employee/payroll/salary/index" */ '@views/employee/payroll/salary/index')
    },
    {
        path: '/employee/payroll/salary/create',
        name: 'employeePayrollSalaryCreate',
        component: () => import(/* webpackChunkName: "js/employee/payroll/salary/create" */ '@views/employee/payroll/salary/create')
    },
    {
        path: '/employee/payroll/salary/:uuid/edit',
        name: 'employeePayrollSalaryEdit',
        component: () => import(/* webpackChunkName: "js/employee/payroll/salary/edit" */ '@views/employee/payroll/salary/edit')
    },
    {
        path: '/employee/payroll/transaction',
        name: 'employeePayrollTransaction',
        component: () => import(/* webpackChunkName: "js/employee/payroll/transaction/index" */ '@views/employee/payroll/transaction/index')
    },
    {
        path: '/employee/payroll/transaction/:uuid/edit',
        name: 'employeePayrollTransactionEdit',
        component: () => import(/* webpackChunkName: "js/employee/payroll/transaction/edit" */ '@views/employee/payroll/transaction/edit')
    },
    {
        path: '/employee/payroll/list',
        name: 'employeePayrollList',
        component: () => import(/* webpackChunkName: "js/employee/payroll/list" */ '@views/employee/payroll/list')
    },
    {
        path: '/employee/payroll/generate',
        name: 'employeePayrollGenerate',
        component: () => import(/* webpackChunkName: "js/employee/payroll/generate" */ '@views/employee/payroll/generate')
    },
    {
        path: 'employee/payroll/bulk-generate',
        name: 'employeePayrollBulkGenerate',
        component: () => import(/* webpackChunkName: "js/employee/payroll/bulk-generate" */ '@views/employee/payroll/bulk-generate')
    },
    {
        path: '/employee/payroll/:uuid/edit',
        name: 'employeePayrollEdit',
        component: () => import(/* webpackChunkName: "js/employee/payroll/edit" */ '@views/employee/payroll/edit')
    },
    {
        path: '/employee/payroll/:uuid',
        name: 'employeePayrollDetail',
        component: () => import(/* webpackChunkName: "js/employee/payroll/show" */ '@views/employee/payroll/show')
    },
    {
        path: '/employee/attendance',
        name: 'employeeAttendance',
        component: () => import(/* webpackChunkName: "js/employee/attendance/index" */ '@views/employee/attendance/index')
    },
    {
        path: '/employee/attendance/regular',
        name: 'employeeRegularAttendance',
        component: () => import(/* webpackChunkName: "js/employee/attendance/regular" */ '@views/employee/attendance/regular')
    },
    {
        path: '/employee/attendance/production',
        name: 'employeeProductionAttendance',
        component: () => import(/* webpackChunkName: "js/employee/attendance/production" */ '@views/employee/attendance/production')
    },
    {
        path: '/employee/list',
        name: 'employeeList',
        component: () => import(/* webpackChunkName: "js/employee/list" */ '@views/employee/list')
    },
    {
        path: '/employee/card-view',
        name: 'employeeCardView',
        component: () => import(/* webpackChunkName: "js/employee/card-view" */ '@views/employee/card-view')
    },
    {
        path: '/employee/:uuid',
        name: 'employeeDetail',
        component: () => import(/* webpackChunkName: "js/employee" */ '@views/employee/show')
    },
    {
        path: '/employee/:uuid/edit',
        name: 'employeeEdit',
        component: () => import(/* webpackChunkName: "js/employee/edit" */ '@views/employee/edit')
    },
    {
        path: '/transport/vehicle',
        name: 'transportVehicle',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/index" */ '@views/transport/vehicle/index')
    },
    {
        path: '/transport/vehicle/:id/edit',
        name: 'transportVehicleEdit',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/edit" */ '@views/transport/vehicle/edit')
    },
    {
        path: '/transport/vehicle/log',
        name: 'transportVehicleLog',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/log/index" */ '@views/transport/vehicle/log/index')
    },
    {
        path: '/transport/vehicle/log/:id/edit',
        name: 'transportVehicleLogEdit',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/log/edit" */ '@views/transport/vehicle/log/edit')
    },
    {
        path: '/transport/vehicle/service/record',
        name: 'transportVehicleServiceRecord',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/serviceRecord/index" */ '@views/transport/vehicle/service-record/index')
    },
    {
        path: '/transport/vehicle/service/record/:id/edit',
        name: 'transportVehicleServiceRecordEdit',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/serviceRecord/edit" */ '@views/transport/vehicle/service-record/edit')
    },
    {
        path: '/transport/vehicle/fuel',
        name: 'transportVehicleFuel',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/fuel/index" */ '@views/transport/vehicle/fuel/index')
    },
    {
        path: '/transport/vehicle/fuel/:id/edit',
        name: 'transportVehicleFuelEdit',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/fuel/edit" */ '@views/transport/vehicle/fuel/edit')
    },
    {
        path: '/transport/vehicle/document',
        name: 'transportVehicleDocument',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/document/index" */ '@views/transport/vehicle/document/index')
    },
    {
        path: '/transport/vehicle/document/:id/edit',
        name: 'transportVehicleDocumentEdit',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/document/edit" */ '@views/transport/vehicle/document/edit')
    },
    {
        path: '/transport/vehicle/incharge',
        name: 'transportVehicleIncharge',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/incharge/index" */ '@views/transport/vehicle/incharge/index')
    },
    {
        path: '/transport/vehicle/performance/criteria',
        name: 'transportVehiclePerformanceCriteria',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/performanceCriteria/index" */ '@views/transport/vehicle/performance-criteria/index')
    },
    {
        path: '/transport/vehicle/performance/criteria/:id/edit',
        name: 'transportVehiclePerformanceCriteriaEdit',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/performanceCriteria/edit" */ '@views/transport/vehicle/performance-criteria/edit')
    },
    {
        path: '/transport/report',
        name: 'transportReport',
        component: () => import(/* webpackChunkName: "js/transport/report" */ '@views/transport/report')
    },
    {
        path: '/reports/index',
        name: 'studentReport',
        component: () => import(/* webpackChunkName: "js/reports/index" */ '@views/reports/index')
    },
    {
        path: '/transport/vehicle/report/summary',
        name: 'transportVehicleSummaryReport',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/report/summary" */ '@views/transport/vehicle/report/summary')
    },
    {
        path: '/meet/live-meeting',
        name: 'LiveMeeting',
        component: () => import(/* webpackChunkName: "js/meet/live_meeting/index" */ '@views/meet/live_meeting/index')
    },
    {
        path: '/meet/live-meeting/report',
        name: 'LiveMeetingReport',
        component: () => import(/* webpackChunkName: "js/meet/live_meeting/report" */ '@views/meet/live_meeting/report')
    },
    {
        path: '/meet/live-class/report',
        name: 'LiveClassReport',
        component: () => import(/* webpackChunkName: "js/meet/live_class/report" */ '@views/meet/live_class/report')
    },
    {
        path: '/meet/live-class',
        name: 'LiveClass',
        component: () => import(/* webpackChunkName: "js/meet/live_class/index" */ '@views/meet/live_class/index')
    },
    {
        path: '/reports/employee-leave-report',
        name: 'EmployeeLeaveReport',
        component: () => import(/* webpackChunkName: "js/reports/employee_leave_report" */ '@views/reports/employee_leave_report')
    },
    {
        path: '/reports/fee-matrix-report',
        name: 'FeeMatrixReport',
        component: () => import(/* webpackChunkName: "js/reports/fee_matrix_report" */ '@views/reports/fee_matrix_report')
    },
    {
        path: '/reports/student-categpory-wise',
        name: 'StudentCategoryWiseReport',
        component: () => import(/* webpackChunkName: "js/reports/student_category_wise_report" */ '@views/reports/student_category_wise_report')
    },
    {
        path: '/reports/student-class-wise',
        name: 'StudentClassWiseReport',
        component: () => import(/* webpackChunkName: "js/reports/student_class_wise_report" */ '@views/reports/student_class_wise_report')
    },
    {
        path: '/reports/disablality-report',
        name: 'StudentDisablityWiseReport',
        component: () => import(/* webpackChunkName: "js/reports/student_disability_wise_report" */ '@views/reports/student_disability_wise_report')
    },
    {
        path: '/reports/student-religion-wise',
        name: 'StudentReligionWiseReport',
        component: () => import(/* webpackChunkName: "js/reports/student_religion_wise_report" */ '@views/reports/student_religion_wise_report')
    },
    {
        path: '/reports/student-age-wise',
        name: 'StudentAgeWiseReport',
        component: () => import(/* webpackChunkName: "js/reports/student_age_wise_report" */ '@views/reports/student_age_wise_report')
    },
    {
        path: '/qr/attendance',
        name: 'QrAttendance',
        component: () => import(/* webpackChunkName: "js/student/attendance/qr" */ '@views/student/attendance/qr')
    },
    {
        path: '/qr/attendance-report',
        name: 'QrAttendanceReport',
        component: () => import(/* webpackChunkName: "js/student/attendance/reports" */ '@views/student/attendance/reports')
    },
    {
        path: '/behaviour/incidents',
        name: 'Incidents',
        component: () => import(/* webpackChunkName: "js/behaviour/incidents/index" */ '@views/behaviour/incidents/index')
    },
    {
        path: '/behaviour/incidents/:id/edit',
        name: 'incidentsEdit',
        component: () => import(/* webpackChunkName: "js/behaviour/incidents/edit" */ '@views/behaviour/incidents/edit')
    },
    {
        path: '/download-center/content-type',
        name: 'contentType',
        component: () => import(/* webpackChunkName: "js/download-center/content-type/index" */ '@views/download-center/content-type/index')
    },
    {
        path: '/download-center/content-type/:id/edit',
        name: 'contentTypeEdit',
        component: () => import(/* webpackChunkName: "js/download-center/content-type/edit" */ '@views/download-center/content-type/edit')
    },
    {
        path: '/download-center/video-tutorial',
        name: 'videoTutorial',
        component: () => import(/* webpackChunkName: "js/download-center/video-tutorial/index" */ '@views/download-center/video-tutorial/index')
    },
    {
        path: '/download-center/video-tutorial/:id/edit',
        name: 'videoTutorialEdit',
        component: () => import(/* webpackChunkName: "js/download-center/video-tutorial/edit" */ '@views/download-center/video-tutorial/edit')
    },
    {
        path: '/download-center/document-share-list',
        name: 'documentShareList',
        component: () => import(/* webpackChunkName: "js/download-center/content-list/document-share-list" */ '@views/download-center/content-list/document-share-list')
    },
    {
        path: '/download-center/content-list/:uuid',
        component: () => import(/* webpackChunkName: "js/download-center/content-list/show" */ '@views/download-center/content-list/show')
    },
    {
        path: '/download-center/content-list',
        name: 'contentList',
        component: () => import(/* webpackChunkName: "js/download-center/content-list/index" */ '@views/download-center/content-list/index')
    },
    {
        path: '/download-center/content-list/:id/edit',
        name: 'contentListEdit',
        component: () => import(/* webpackChunkName: "js/download-center/content-list/edit" */ '@views/download-center/content-list/edit')
    },
    {
        path: '/behaviour/assign',
        name: 'assignBehaviour',
        component: () => import(/* webpackChunkName: "js/behaviour/incidents/assign" */ '@views/behaviour/incidents/assign')
    },
    {
        path: '/behaviour/reports',
        name: 'assignBehaviourReports',
        component: () => import(/* webpackChunkName: "js/behaviour/report" */ '@views/behaviour/report')
    },
    {
        path: '/behaviour/reports/student-behaviour-rank-report',
        name: 'assignBehaviourReportsRank',
        component: () => import(/* webpackChunkName: "js/behaviour/report/student_behaviour_rank_report" */ '@views/behaviour/report/student_behaviour_rank_report')
    },
    {
        path: '/behaviour/reports/student-class-rank-report',
        name: 'assignBehaviourReportsClass',
        component: () => import(/* webpackChunkName: "js/behaviour/report/student_behaviour_class_rank_report" */ '@views/behaviour/report/student_behaviour_class_rank_report')
    },
    {
        path: '/behaviour/reports/student-class-section-rank-report',
        name: 'assignBehaviourReportsSection',
        component: () => import(/* webpackChunkName: "js/behaviour/report/student_behaviour_class_section_rank_report" */ '@views/behaviour/report/student_behaviour_class_section_rank_report')
    },
    {
        path: '/behaviour/reports/incident-report',
        name: 'assignBehaviourReportsIncident',
        component: () => import(/* webpackChunkName: "js/behaviour/report/incident_report" */ '@views/behaviour/report/incident_report')
    },
    {
        path: '/hostel/hostel',
        name: 'hostel',
        component: () => import(/* webpackChunkName: "js/hostel/hostel/index" */ '@views/hostel/hostel/index')
    },
    {
        path: '/hostel/hostel/:id/edit',
        name: 'hostelEdit',
        component: () => import(/* webpackChunkName: "js/hostel/hostel/edit" */ '@views/hostel/hostel/edit')
    },
    {
        path: '/hostel/facilities',
        name: 'hostelFacilities',
        component: () => import(/* webpackChunkName: "js/hostel/facilities/index" */ '@views/hostel/facilities/index')
    },
    {
        path: '/hostel/facilities/:id/edit',
        name: 'hostelFacilitiesEdit',
        component: () => import(/* webpackChunkName: "js/hostel/facilities/edit" */ '@views/hostel/facilities/edit')
    },
    {
        path: '/hostel/rooms',
        name: 'hostelRooms',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/index" */ '@views/hostel/rooms/index')
    },
    {
        path: '/hostel/rooms/:id/edit',
        name: 'hostelRoomsEdit',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/edit" */ '@views/hostel/rooms/edit')
    },
    {
        path: '/hostel/incharge',
        name: 'hostelIncharge',
        component: () => import(/* webpackChunkName: "js/transport/vehicle/incharge/index" */ '@views/hostel/incharge/index')
    },
    {
        path: '/hostel/food-menu',
        name: 'hostelFoodMenu',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/index" */ '@views/hostel/food_menu/index')
    },
    {
        path: '/hostel/food-menu/:id/edit',
        name: 'hostelFoodMenuEdit',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/edit" */ '@views/hostel/food_menu/edit')
    },
    {
        path: '/hostel/meal-schedule',
        name: 'hostelMealSchedule',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/index" */ '@views/hostel/meal_schedule/index')
    },
    {
        path: '/hostel/meal-schedule/:id/edit',
        name: 'hostelMealScheduleEdit',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/edit" */ '@views/hostel/meal_schedule/edit')
    },
    {
        path: '/hostel/meal-plan',
        name: 'hostelMealPlan',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/index" */ '@views/hostel/meal_plan/index')
    },
    {
        path: '/hostel/meal-plan/:id/edit',
        name: 'hostelMealPlanEdit',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/edit" */ '@views/hostel/meal_plan/edit')
    },
    {
        path: '/hostel/meal-plan/:id/plan',
        name: 'hostelMealPlaViewPlan',
        component: () => import(/* webpackChunkName: "js/hostel/rooms/edit" */ '@views/hostel/meal_plan/viewPlan')
    },
    {
        path: '/hostel/report',
        name: 'hostelReport',
        component: () => import(/* webpackChunkName: "js/hostel/report" */ '@views/hostel/report')
    },
    {
        path: '/hostel/report/assign-vacate',
        name: 'hostelReportAssignVacate',
        component: () => import(/* webpackChunkName: "js/hostel/report" */ '@views/hostel/reportAssignVacate')
    },
    {
        path: '/hostel/report/meal-plan',
        name: 'hostelReportMealPlan',
        component: () => import(/* webpackChunkName: "js/hostel/report" */ '@views/hostel/reportMealPlan')
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: () => import(/* webpackChunkName: "js/calendar/index" */ '@views/calendar/index')
    },
    {
        path: '/calendar/holiday',
        name: 'calendarHoliday',
        component: () => import(/* webpackChunkName: "js/calendar/holiday/index" */ '@views/calendar/holiday/index')
    },
    {
        path: '/calendar/holiday/:id/edit',
        name: 'calendarHolidayEdit',
        component: () => import(/* webpackChunkName: "js/calendar/holiday/index" */ '@views/calendar/holiday/index')
    },
    {
        path: '/calendar/event',
        name: 'calendarEvent',
        component: () => import(/* webpackChunkName: "js/calendar/event/index" */ '@views/calendar/event/index')
    },
    {
        path: '/calendar/event/create',
        name: 'calendarEventCreate',
        component: () => import(/* webpackChunkName: "js/calendar/event/index" */ '@views/calendar/event/index')
    },
    {
        path: '/calendar/event/:uuid/edit',
        name: 'calendarEventEdit',
        component: () => import(/* webpackChunkName: "js/calendar/event/index" */ '@views/calendar/event/index')
    },
    {
        path: '/calendar/celebration/birthday',
        name: 'calendarBirthdayCelebration',
        component: () => import(/* webpackChunkName: "js/calendar/celebration/birthday" */ '@views/calendar/celebration/birthday')
    },
    {
        path: '/calendar/celebration/anniversary',
        name: 'calendarAnniversaryCelebration',
        component: () => import(/* webpackChunkName: "js/calendar/celebration/anniversary" */ '@views/calendar/celebration/anniversary')
    },
    {
        path: '/calendar/celebration/work/anniversary',
        name: 'calendarWorkAnniversaryCelebration',
        component: () => import(/* webpackChunkName: "js/calendar/celebration/workAnniversary" */ '@views/calendar/celebration/work-anniversary')
    },
    {
        path: '/frontend',
        name: 'frontend',
        component: () => import(/* webpackChunkName: "js/frontend/index" */ '@views/frontend/index')
    },
    {
        path: '/frontend/page',
        name: 'frontendPage',
        component: () => import(/* webpackChunkName: "js/frontend/page/index" */ '@views/frontend/page/index')
    },
    {
        path: '/frontend/page/:uuid/edit',
        name: 'frontendPageEdit',
        component: () => import(/* webpackChunkName: "js/frontend/page/index" */ '@views/frontend/page/index')
    },
    {
        path: '/frontend/page/:uuid',
        name: 'frontendPageDetail',
        component: () => import(/* webpackChunkName: "js/frontend/page/edit" */ '@views/frontend/page/edit')
    },
    {
        path: '/frontend/block',
        name: 'frontendBlock',
        component: () => import(/* webpackChunkName: "js/frontend/block/index" */ '@views/frontend/block/index')
    },
    {
        path: '/frontend/block/:uuid/edit',
        name: 'frontendBlockEdit',
        component: () => import(/* webpackChunkName: "js/frontend/block/index" */ '@views/frontend/block/index')
    },
    {
        path: '/frontend/block/:uuid',
        name: 'frontendBlockDetail',
        component: () => import(/* webpackChunkName: "js/frontend/block/edit" */ '@views/frontend/block/edit')
    },
    {
        path: '/frontend/menu',
        name: 'frontendMenu',
        component: () => import(/* webpackChunkName: "js/frontend/menu/index" */ '@views/frontend/menu/index')
    },
    {
        path: '/frontend/menu/:id/edit',
        name: 'frontendMenuEdit',
        component: () => import(/* webpackChunkName: "js/frontend/menu/index" */ '@views/frontend/menu/index')
    },
    {
        path: '/frontend/slider',
        name: 'frontendSlider',
        component: () => import(/* webpackChunkName: "js/frontend/slider/index" */ '@views/frontend/slider/index')
    },
    {
        path: '/frontend/slider/:id/edit',
        name: 'frontendSliderEdit',
        component: () => import(/* webpackChunkName: "js/frontend/slider/index" */ '@views/frontend/slider/index')
    },
    {
        path: '/frontend/news',
        name: 'frontendNews',
        component: () => import(/* webpackChunkName: "js/frontend/news/index" */ '@views/frontend/news/index')
    },
    {
        path: '/frontend/news/:uuid/edit',
        name: 'frontendNewsEdit',
        component: () => import(/* webpackChunkName: "js/frontend/news/index" */ '@views/frontend/news/index')
    },
    {
        path: '/post',
        name: 'post',
        component: () => import(/* webpackChunkName: "js/post/index" */ '@views/post/index')
    },
    {
        path: '/post/article',
        name: 'postArticle',
        component: () => import(/* webpackChunkName: "js/post/article/index" */ '@views/post/article/index')
    },
    {
        path: '/post/article/:uuid/edit',
        name: 'postArticleEdit',
        component: () => import(/* webpackChunkName: "js/post/article/index" */ '@views/post/article/index')
    },{
        path: '/post/article/create',
        name: 'postArticleCreate',
        component: () => import(/* webpackChunkName: "js/post/article/index" */ '@views/post/article/index')
    },
    {
        path: '/post/feed',
        name: 'postFeed',
        component: () => import(/* webpackChunkName: "js/post/feed/index" */ '@views/post/feed/index')
    },
    {
        path: '/reception',
        name: 'reception',
        component: () => import(/* webpackChunkName: "js/reception/index" */ '@views/reception/index')
    },
    {
        path: '/reception/enquiry',
        name: 'receptionEnquiry',
        component: () => import(/* webpackChunkName: "js/reception/enquiry/index" */ '@views/reception/enquiry/index')
    },
    {
        path: '/reception/enquiry/:uuid/edit',
        name: 'receptionEnquiryEdit',
        component: () => import(/* webpackChunkName: "js/reception/enquiry/index" */ '@views/reception/enquiry/index')
    },
    {
        path: '/reception/enquiry/:uuid',
        name: 'receptionEnquiryDetail',
        component: () => import(/* webpackChunkName: "js/reception/enquiry/show" */ '@views/reception/enquiry/show')
    },
    {
        path: '/reception/visitor/log',
        name: 'receptionVisitorLog',
        component: () => import(/* webpackChunkName: "js/reception/visitorLog/index" */ '@views/reception/visitor-log/index')
    },
    {
        path: '/reception/visitor/log/:uuid/edit',
        name: 'receptionVisitorLogEdit',
        component: () => import(/* webpackChunkName: "js/reception/visitorLog/index" */ '@views/reception/visitor-log/index')
    },
    {
        path: '/reception/call/log',
        name: 'receptionCallLog',
        component: () => import(/* webpackChunkName: "js/reception/callLog/index" */ '@views/reception/call-log/index')
    },
    {
        path: '/reception/call/log/:uuid/edit',
        name: 'receptionCallLogEdit',
        component: () => import(/* webpackChunkName: "js/reception/callLog/index" */ '@views/reception/call-log/index')
    },
    {
        path: '/reception/complaint',
        name: 'receptionComplaint',
        component: () => import(/* webpackChunkName: "js/reception/complaint/index" */ '@views/reception/complaint/index')
    },
    {
        path: '/reception/complaint/:uuid/edit',
        name: 'receptionComplaintEdit',
        component: () => import(/* webpackChunkName: "js/reception/complaint/index" */ '@views/reception/complaint/index')
    },
    {
        path: '/reception/gate/pass',
        name: 'receptionGatePass',
        component: () => import(/* webpackChunkName: "js/reception/gatePass/index" */ '@views/reception/gate-pass/index')
    },
    {
        path: '/reception/gate/pass/:uuid/edit',
        name: 'receptionGatePassEdit',
        component: () => import(/* webpackChunkName: "js/reception/gatePass/index" */ '@views/reception/gate-pass/index')
    },
    {
        path: '/reception/postal/record',
        name: 'receptionPostalRecord',
        component: () => import(/* webpackChunkName: "js/reception/postalRecord/index" */ '@views/reception/postal-record/index')
    },
    {
        path: '/reception/postal/record/:uuid/edit',
        name: 'receptionPostalRecordEdit',
        component: () => import(/* webpackChunkName: "js/reception/postalRecord/index" */ '@views/reception/postal-record/index')
    },
    {
        path: '/reception/postal/record/:uuid',
        name: 'receptionPostalRecordDetail',
        component: () => import(/* webpackChunkName: "js/reception/postalRecord/show" */ '@views/reception/postal-record/show')
    },
    {
        path: '/reception/visitor/message',
        name: 'receptionVisitorMessage',
        component: () => import(/* webpackChunkName: "js/reception/visitorMessage/index" */ '@views/reception/visitor-message/index')
    },
    {
        path: '/communication',
        name: 'communication',
        component: () => import(/* webpackChunkName: "js/communication/index" */ '@views/communication/index')
    },
    {
        path: '/communication/notification',
        name: 'myNotification',
        component: () => import(/* webpackChunkName: "js/communication/notification" */ '@views/communication/notification')
    },
    {
        path: '/inventory/stock/category',
        name: 'inventoryStockCategory',
        component: () => import(/* webpackChunkName: "js/inventory/stock-category/index" */ '@views/inventory/stock-category/index')
    },
    {
        path: '/inventory/stock/category/:id/edit',
        name: 'inventoryStockCategoryEdit',
        component: () => import(/* webpackChunkName: "js/inventory/stock-category/edit" */ '@views/inventory/stock-category/edit')
    },
    {
        path: '/inventory/stock/item',
        name: 'inventoryStockItem',
        component: () => import(/* webpackChunkName: "js/inventory/stock-item/index" */ '@views/inventory/stock-item/index')
    },
    {
        path: '/inventory/stock/item/:id/edit',
        name: 'inventoryStockItemEdit',
        component: () => import(/* webpackChunkName: "js/inventory/stock-item/edit" */ '@views/inventory/stock-item/edit')
    },
    {
        path: '/inventory/stock/purchase',
        name: 'inventoryStockPurchase',
        component: () => import(/* webpackChunkName: "js/inventory/stock-purchase/index" */ '@views/inventory/stock-purchase/index')
    },
    {
        path: '/inventory/stock/purchase/:id/edit',
        name: 'inventoryStockPurchaseEdit',
        component: () => import(/* webpackChunkName: "js/inventory/stock-purchase/edit" */ '@views/inventory/stock-purchase/edit')
    },
    {
        path: '/inventory/stock/purchase/:id',
        name: 'inventoryStockPurchaseDetail',
        component: () => import(/* webpackChunkName: "js/inventory/stock-purchase/show" */ '@views/inventory/stock-purchase/show')
    },
    {
        path: '/inventory/stock/transfer',
        name: 'inventoryStockTransfer',
        component: () => import(/* webpackChunkName: "js/inventory/stock-transfer/index" */ '@views/inventory/stock-transfer/index')
    },
    {
        path: '/inventory/stock/transfer/:id/edit',
        name: 'inventoryStockTransferEdit',
        component: () => import(/* webpackChunkName: "js/inventory/stock-transfer/edit" */ '@views/inventory/stock-transfer/edit')
    },
    {
        path: '/inventory/stock/transfer/:id',
        name: 'inventoryStockTransferDetail',
        component: () => import(/* webpackChunkName: "js/inventory/stock-transfer/show" */ '@views/inventory/stock-transfer/show')
    },
    {
        path: '/inventory/vendor',
        name: 'inventoryVendor',
        component: () => import(/* webpackChunkName: "js/inventory/vendor/index" */ '@views/inventory/vendor/index')
    },
    {
        path: '/inventory/vendor/:id/edit',
        name: 'inventoryVendorEdit',
        component: () => import(/* webpackChunkName: "js/inventory/vendor/edit" */ '@views/inventory/vendor/edit')
    },
    {
        path: '/communication/sms',
        name: 'communicationSMS',
        component: () => import(/* webpackChunkName: "js/communication/sms/index" */ '@views/communication/sms/index')
    },
    {
        path: '/communication/whatsapp',
        name: 'communicationSMS',
        component: () => import(/* webpackChunkName: "js/communication/whatsapp/index" */ '@views/communication/whatsapp/index')
    },
    {
        path: '/communication/balance',
        name: 'communicationBalance',
        component: () => import(/* webpackChunkName: "js/communication/balance/index" */ '@views/communication/balance/index')
    },
    {
        path: '/communication/push-notification',
        name: 'communicationPushNotification',
        component: () => import(/* webpackChunkName: "js/communication/push-notification/index" */ '@views/communication/push-notification/index')
    },
    {
        path: '/communication/email',
        name: 'communicationEmail',
        component: () => import(/* webpackChunkName: "js/communication/email/index" */ '@views/communication/email/index')
    },
    {
        path: '/institute/document',
        name: 'instituteDocument',
        component: () => import(/* webpackChunkName: "js/institute/document/index" */ '@views/institute/document/index')
    },
    {
        path: '/institute/document/:id/edit',
        name: 'instituteEdit',
        component: () => import(/* webpackChunkName: "js/institute/document/index" */ '@views/institute/document/index')
    }
]